import type { Dispatch, SetStateAction } from 'react';
import React from 'react';

import UserNav, { AuthOffUserNav } from '../UserNav';

interface Auth {
  isAuthEnabled?: boolean;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setWidthOfModal: Dispatch<SetStateAction<number | null>>;
}

export const AuthUserNav = ({ isAuthEnabled, isOpen, setIsOpen, setWidthOfModal }: Auth): React.ReactElement =>
  isAuthEnabled ? (
    <UserNav isOpen={isOpen} setIsOpen={setIsOpen} setWidthOfModal={setWidthOfModal} />
  ) : (
    <AuthOffUserNav isOpen={isOpen} setIsOpen={setIsOpen} setWidthOfModal={setWidthOfModal} />
  );
